<template>
  <div>
    <div class="onborading-block block">
      <div class="block reltaive pl-5 pr-5 pb-28">
        <div class="block relative onboarditem-block">
          <VueSlickCarousel
            ref="onBoardCarousel"
            :dots="true"
            @beforeChange="beforeChange"
          >
            <div>
              <div class="block relative">
                <div
                  class="
                    imgbox-block
                    block
                    relative
                    h-auto
                    imgmin
                    flex
                    items-center
                    justify-center
                  "
                >
                  <img
                    src="./../assets/images/onborad1.png"
                    alt="onborading img"
                    class="w-full h-full"
                  />
                </div>
                <div class="information-block block relative">
                  <h2
                    class="
                      block
                      onBoardTitle
                      text-darkblack
                      font-bold
                      relative
                      mb-1.5
                      text-center
                    "
                  >
                    {{ $t("pages.onBoarding.firstPageHeading") }}
                  </h2>
                  <p
                    class="
                      block
                      text-xss
                      font-normal
                      text-darkblack
                      relative
                      text-center
                      mb-6
                      pl-14
                      pr-14
                    "
                  >
                    {{ $t("pages.onBoarding.firstPageSubHeading") }}
                  </p>
                </div>
              </div>
            </div>
            <div>
              <div class="block relative">
                <div
                  class="
                    imgbox-block
                    block
                    relative
                    h-auto
                    imgmin
                    flex
                    items-center
                    justify-center
                  "
                >
                  <img
                    src="./../assets/images/onborad2.png"
                    alt="onborading img "
                    class="w-full h-full"
                  />
                </div>
                <div class="information-block block relative">
                  <h2
                    class="
                      block
                      onBoardTitle
                      text-darkblack
                      font-bold
                      relative
                      mb-1.5
                      text-center
                    "
                  >
                    {{ $t("pages.onBoarding.secondPageHeading") }}
                  </h2>
                  <p
                    class="
                      block
                      text-xss
                      font-normal
                      text-darkblack
                      relative
                      text-center
                      mb-6
                      pl-14
                      pr-14
                    "
                  >
                    {{ $t("pages.onBoarding.secondPageSubHeading") }}
                  </p>
                </div>
              </div>
            </div>
            <div>
              <div class="block relative">
                <div
                  class="
                    imgbox-block
                    block
                    relative
                    h-auto
                    imgmin
                    flex
                    items-center
                    justify-center
                  "
                >
                  <img
                    src="./../assets/images/onborad3.png"
                    alt="onborading img "
                    class="w-full h-full"
                  />
                </div>
                <div class="information-block block relative">
                  <h2
                    class="
                      block
                      onBoardTitle
                      text-darkblack
                      font-bold
                      relative
                      mb-1.5
                      text-center
                    "
                  >
                    {{ $t("pages.onBoarding.thirdPageHeading") }}
                  </h2>
                  <p
                    class="
                      block
                      text-xss
                      font-normal
                      text-darkblack
                      relative
                      text-center
                      mb-6
                      pl-14
                      pr-14
                    "
                  >
                    {{ $t("pages.onBoarding.thirdPageSubHeading") }}.
                  </p>
                </div>
              </div>
            </div>
            <div>
              <div class="block relative">
                <div
                  class="
                    imgbox-block
                    block
                    relative
                    h-auto
                    imgmin
                    flex
                    items-center
                    justify-center
                  "
                >
                  <img
                    src="./../assets/images/onborad4.png"
                    alt="onborading img "
                    class="w-full h-full"
                  />
                </div>
                <div class="information-block block relative">
                  <h2
                    class="
                      block
                      onBoardTitle
                      text-darkblack
                      font-bold
                      relative
                      mb-1.5
                      text-center
                    "
                  >
                    {{ $t("pages.onBoarding.forthPageHeading") }}.
                  </h2>
                  <p
                    class="
                      block
                      text-xss
                      font-normal
                      text-darkblack
                      relative
                      text-center
                      mb-6
                      pl-14
                      pr-14
                    "
                  >
                    {{ $t("pages.onBoarding.fouthPageSubHeading") }}.
                  </p>
                </div>
              </div>
            </div>
          </VueSlickCarousel>
        </div>
        <div
          class="
            block
            fixed
            left-0
            bottom-0
            w-full
            btn-block
            pt-6
            pb-6
            pl-7
            pr-7
            bg-white
          "
        >
          <button
            class="
              relative
              flex
              items-center
              justify-center
              flex-nowrap
              text-sm
              walter-footer
              p-1.5
              border
              solid
              border-darkgreen
              rounded
              w-full
              text-center
              bg-darkgreen
              h-12
              text-white
            "
            @click="$refs.onBoardCarousel.next()"
          >
            {{ $t("pages.onBoarding.continue_button_text") }}.
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
export default {
  name: "Onboarding",
  components: { VueSlickCarousel },
  methods: {
    beforeChange(oldIdx, newIdx) {
 
      if (newIdx === 0) {
        if (this.$route.query[0] === true) {
          this.$router.push({ name: "checkLastname" });
        } else {
          this.$router.push({ name: "offerSearch" });
        }
      }
    },
  },
};
</script>
<style>
.slick-dots li button {
  border: 1px solid #63b15b;
  border-radius: 100%;
  width: 10px;
  height: 10px;
  padding: 0;
  border-radius: 46px;
}

.slick-dots li button:before {
  display: none;
}

.slick-dots li {
  width: auto;
  height: auto;
  margin: 0;
  margin-right: 8px;
}
.slick-dots li.slick-active button {
  background: #63b15b;
  width: 55px;
}

.slick-dots {
  bottom: -5px;
}
body {
  padding-bottom: 0 !important;
}
.imgmin {
  min-height: 25rem;
}
</style>
